import { mergeAttributes } from "@tiptap/react"
import TiptapHorizontalRule from "@tiptap/extension-horizontal-rule"

export const HorizontalRule = TiptapHorizontalRule.extend({
  parseHTML() {
    return [
      // Claim our own serialized wrapper with a priority above the generic
      // html-preservation Div node, so save/reopen round trips don't nest an
      // extra div around the rule each time.
      { tag: `div[data-type="${this.name}"]`, priority: 100 },
      { tag: "hr" },
    ]
  },

  renderHTML() {
    return [
      "div",
      mergeAttributes(this.options.HTMLAttributes, { "data-type": this.name }),
      ["hr"],
    ];
  },
})

export default HorizontalRule
